import React from 'react'

const DefaultBadgesFour = () => {
    return (
        <div className="col-md-6">
            <div className="card h-100 p-0">
                <div className="card-header border-bottom bg-base py-16 px-24">
                    <h6 className="text-lg fw-semibold mb-0">Default Badges</h6>
                </div>
                <div className="card-body p-24">
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 bg-primary-600  text-white">
                            1
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 bg-lilac-600  text-white">
                            2
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 bg-success-600  text-white">
                            3
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 bg-warning-600  text-white">
                            4
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 bg-danger-600  text-white">
                            5
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 text-primary-600 bg-primary-50 radius-4 text-white">
                            1
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 text-lilac-600 bg-lilac-100 radius-4 text-white">
                            2
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 text-success-600 bg-success-100 radius-4 text-white">
                            3
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 text-warning-600 bg-warning-100 radius-4 text-white">
                            4
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 text-danger-600 bg-danger-100 radius-4 text-white">
                            5
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 border border-primary-600 text-primary-600 radius-4 text-white">
                            1
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 border border-lilac-600 text-lilac-600 radius-4 text-white">
                            2
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 border border-success-600 text-success-600 radius-4 text-white">
                            3
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 border border-warning-600 text-warning-600 radius-4 text-white">
                            4
                        </span>
                        <span className="badge text-sm fw-semibold w-32-px h-32-px d-flex justify-content-center align-items-center radius-4 border border-danger-600 text-danger-600 radius-4 text-white">
                            5
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DefaultBadgesFour